import React from 'react'
import i18n from 'i18next'

import Typography from '../../../../UniformComponents/Typography'
import { countFilterRules } from './popoverPlacement'

const NoChartData = ({ question }) => {
    const removeBaseLimit = question?.settings?.removeBaseLimit || 0
    const hasFilters = countFilterRules(question?.filter?.question) > 0
    const hasReason = hasFilters || removeBaseLimit > 0

    return (
        <div className="pp-chart-no-data">
            <i className="far fa-chart-column" />
            <Typography type="tiny" color="grey">{i18n.t('powerpoint.slide.no-data')}</Typography>

            {hasReason && (
                <div className="pp-chart-no-data-reasons">
                    {hasFilters && (
                        <Typography type="tiniest" color="grey">
                            {i18n.t('powerpoint.slide.no-data-filters')}
                        </Typography>
                    )}
                    {removeBaseLimit > 0 && (
                        <Typography type="tiniest" color="grey">
                            {i18n.t('powerpoint.slide.no-data-base-limit', { 1: removeBaseLimit })}
                        </Typography>
                    )}
                </div>
            )}
        </div>
    )
}

export default NoChartData
